// Home Slider
export let HomeSlider: any = {
    loop: true,
    autoplay: true,
    autoplayTimeout: 5000,
    smartSpeed: 900,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    navSpeed: 300,
    nav: true,
    dots: true,
    navContainerClass: 'owl-nav',
    navClass: ['owl-prev', 'owl-next'],
    navText: ['<i class="ti-angle-left"></i>', '<i class="ti-angle-right"></i>'],
    responsive: {
        0: {
            items: 1
        },
        400: {
            items: 1
        },
        740: {
            items: 1
        },
        940: {
            items: 1
        }
    },
};
// Home Slider
export let HomeSliderPhrase: any = {
    loop: true,
    autoplay: true,
    autoplayTimeout: 5000,
    smartSpeed: 900,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    navSpeed: 300,
    nav: true,
    dots: true,
    navContainerClass: 'owl-nav',
    navClass: ['owl-prev', 'owl-next'],
    navText: ['<i class="ti-angle-left"></i>', '<i class="ti-angle-right"></i>'],
    responsive: {
        0: {
            items: 1
        },
        400: {
            items: 1
        },
        740: {
            items: 1
        },
        940: {
            items: 1
        }
    },
};

export let VisitSlider: any = {
    loop: true,
    autoplay: true,
    autoplayTimeout: 5000,
    smartSpeed: 900,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    navSpeed: 500,
    nav: true,
    dots: true,
    navContainerClass: 'owl-nav',
    navClass: ['owl-prev', 'owl-next'],
    navText: ['<i class="ti-angle-left"></i>', '<i class="ti-angle-right"></i>'],
    responsive: {
        0: {
            items: 1
        },
        400: {
            items: 1
        },
        740: {
            items: 1
        },
        940: {
            items: 1
        }
    },
};